import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CategoryScroll from './components/CategoryScroll';
import CategoryGrid from './components/CategoryGrid';
import ArticlePreview from './components/ArticlePreview';
import AboutSection from './components/AboutSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import JsonLd from '@/components/base/JsonLd';

const siteUrl = typeof __VITE_SITE_URL__ !== 'undefined' ? __VITE_SITE_URL__ : 'https://yoybuy.boats';

const websiteJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'YOYBUY.boats',
  url: siteUrl,
  description: 'Профессиональная система спредшитов для поиска и анализа товаров из Китая',
  inLanguage: 'ru',
  potentialAction: {
    '@type': 'SearchAction',
    target: `${siteUrl}/search?q={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <main>
      <JsonLd data={websiteJsonLd} />
      <Navbar />
      <Hero />

      <section className="relative py-6 bg-background-50">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-px h-full bg-gradient-to-b from-transparent via-background-300/40 to-transparent hidden lg:block"></div>
      </section>

      <CategoryScroll />
      <CategoryGrid />
      <ArticlePreview />
      <AboutSection />
      <CTASection />
      <Footer />
    </main>
  );
}